import { useEffect, useRef, useState } from 'react';
import { authFetch } from "./authFetch";

// Replace only values filled by us or still empty; retain operator corrections.
export function mergeVehicleFields(current, next = {}, previous = {}) {
  const result = { ...current };
  for (const key of new Set([...Object.keys(previous), ...Object.keys(next)])) {
    if (current[key] == null || current[key] === '' ||
        (previous[key] != null && String(current[key]) === String(previous[key]))) {
      result[key] = next[key] ?? '';
    }
  }
  return result;
}

export default function useVehicleHistory(vin, enabled, apply) {
  const callback = useRef(apply);
  callback.current = apply;
  const previous = useRef(null);
  const [message, setMessage] = useState('');
  const normalized = (vin || '').replace(/\s/g, '').toUpperCase();
  useEffect(() => {
    let active = true;
    setMessage('');
    if (!enabled) {
      previous.current = null;
      return;
    }
    if (previous.current) {
      callback.current(null, previous.current);
      previous.current = null;
    }
    if (normalized.length < 3) return;
    const timer = setTimeout(async () => {
      setMessage('Caut ultimul deviz pentru VIN...');
      try {
        const data = await authFetch(`/comenzi/service/ultimul-deviz-vin?vin=${encodeURIComponent(normalized)}`);
        if (!active) return;
        if (data) {
          callback.current(data, null);
          previous.current = data;
          setMessage(`Date preluate din devizul ${data.bxnumar_comanda || data.bxid} (${String(data.bxdata_comanda || '').slice(0, 10)}). Verificați clientul și datele mașinii.`);
        } else {
          setMessage('Nu există un deviz anterior pentru acest VIN.');
        }
      } catch (error) {
        if (active) setMessage('Nu am putut verifica VIN-ul. Reintroduceți VIN-ul pentru a reîncerca.');
      }
    }, 600);
    return () => { active = false; clearTimeout(timer); };
  }, [normalized, enabled]);
  return message;
}

export function vehicleCustomer(data) {
  return data ? { bxcustomer_id: data.bxcustomer_id || '', customer_name: data.customer_name || '' } : {};
}
export function vehicleDetails(data, clientOrder = false) {
  return data ? { ...data.service_details, ...(clientOrder ? { numar_auto: data.bxnumar || '' } : {}) } : {};
}
